const state = {
    performanceRecords: [],
    loading: false
};

export default state;